import * as angular from 'angular';
import { MeurhVagasValetransporteFormController } from './valetransporte.form.controller';

export class MeurhVagasValetransporteFormComponent implements angular.IComponentOptions {
	static selector = 'meurhVagasValetransporteFormComponent';
	static controller = MeurhVagasValetransporteFormController;
	static template = require('!!html-loader!./valetransporte.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
